// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class DigitalpaymentBankAccountDetail {
    static getAttributeTypeMap() {
        return DigitalpaymentBankAccountDetail.attributeTypeMap;
    }
}
DigitalpaymentBankAccountDetail.discriminator = undefined;
DigitalpaymentBankAccountDetail.additionalProperties = false;
DigitalpaymentBankAccountDetail.attributeTypeMap = [
    {
        "name": "accountNumberLastFour",
        "baseName": "accountNumberLastFour",
        "type": "string"
    },
];
//# sourceMappingURL=digitalpaymentBankAccountDetail.js.map